import { createSelector } from 'reselect'
import { RootState } from '../types'
import { LoadingStateEnum } from '../../types'

export const getSfWalletsLoadingState = (state: RootState): RootState['sfWallets']['loading'] => state.sfWallets.loading

export const sfWalletsIsLoading = createSelector(
  getSfWalletsLoadingState,
  (state): boolean => state === LoadingStateEnum.LOADING,
)

export const getSfWalletsData = (state: RootState): RootState['sfWallets']['data'] => state.sfWallets.data
export const getSfWalletsError = (state: RootState): RootState['sfWallets']['error'] => state.sfWallets.error

export const getAssignedWalletsLoadingState = (
  state: RootState,
): RootState['sfWallets']['assignedUserWallets']['loading'] => state.sfWallets.assignedUserWallets.loading

export const assignedWalletsIsLoading = createSelector(
  getAssignedWalletsLoadingState,
  (state): boolean => state === LoadingStateEnum.LOADING,
)

export const getAssignedWalletIdsByUser = (
  state: RootState,
): RootState['sfWallets']['assignedUserWallets']['assignedIds'] => state.sfWallets.assignedUserWallets.assignedIds

export const getAssignedWalletsByUser = (state: RootState): RootState['sfWallets']['assignedUserWallets']['data'] =>
  state.sfWallets.assignedUserWallets.data
